import { render, staticRenderFns } from "./searchRequestForm.vue?vue&type=template&id=b3a477f8&"
import script from "./searchRequestForm.vue?vue&type=script&lang=js&"
export * from "./searchRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports